import { ReportRepository } from "@domain/repositories/ReportRepository";
import UseCase from "@domain/UseCase";

type Input = void;

type Output = void;

export class GetReturnClientsReports implements UseCase<Input, Output> {
  constructor(private readonly reportRepository: ReportRepository) {}

  execute() {
    return this.reportRepository.getReturnClientsReports();
  }
}
